import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const LoadingButton = ({ onClick, children, className = "", successText = "Acquired" }) => {
  const [status, setStatus] = useState('idle'); // idle, loading, success

  const handleAction = async () => {
    if (status !== 'idle') return;
    setStatus('loading');
    
    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 1200));
    
    setStatus('success');
    if (onClick) onClick();
    
    setTimeout(() => setStatus('idle'), 2000);
  };

  return (
    <button 
      onClick={handleAction}
      disabled={status === 'loading'}
      className={`relative overflow-hidden transition-all duration-300 disabled:cursor-not-allowed ${className}`}
    >
      <AnimatePresence mode="wait">
        {status === 'idle' && (
          <motion.span 
            key="idle"
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            exit={{ opacity: 0 }}
            className="flex items-center justify-center gap-2"
          >
            {children}
          </motion.span>
        )}
        {status === 'loading' && (
          <motion.span 
            key="loading"
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            exit={{ opacity: 0 }}
            className="flex items-center justify-center"
          >
            <SafeIcon icon={FiIcons.FiLoader} className="animate-spin text-xl" />
          </motion.span>
        )}
        {status === 'success' && (
          <motion.span 
            key="success"
            initial={{ opacity: 0, y: 10 }} 
            animate={{ opacity: 1, y: 0 }} 
            exit={{ opacity: 0 }}
            className="flex items-center justify-center gap-2 text-white"
          >
            <SafeIcon icon={FiIcons.FiCheckCircle} /> {successText}
          </motion.span>
        )}
      </AnimatePresence>
    </button>
  );
};

export default LoadingButton;